import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTextItemMediaPanelHandlerComponent } from './fi-text-item-media-panel-handler.component';
import { FiTextItemMediaPanelFileSettingsComponent } from './fi-text-item-media-panel-settings/fi-text-item-media-panel-settings.component';
import { FiTextItemMediaPanelItemBaseComponent } from './fi-text-item-media-panel-item-base/fi-text-item-media-panel-item-base.component';
import { FiTextItemMediaPanelAlignmentComponent } from './fi-text-item-media-panel-alignment/fi-text-item-media-panel-alignment.component';
import { FiTextItemMediaPanelSizeComponent } from './fi-text-item-media-panel-size/fi-text-item-media-panel-size.component';
import { FiTextItemMediaPanelLinkComponent } from './fi-text-item-media-panel-link/fi-text-item-media-panel-link.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiTextItemMediaSettingsDialogComponent } from './fi-text-item-media-settings-dialog/fi-text-item-media-settings-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    declarations: [
        FiTextItemMediaPanelHandlerComponent,
        FiTextItemMediaPanelFileSettingsComponent,
        FiTextItemMediaPanelItemBaseComponent,
        FiTextItemMediaPanelAlignmentComponent,
        FiTextItemMediaPanelSizeComponent,
        FiTextItemMediaPanelLinkComponent,
        FiTextItemMediaSettingsDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FiAppTextSharedModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
    ],
    exports: [
        FiTextItemMediaPanelHandlerComponent,
        FiTextItemMediaPanelFileSettingsComponent,
        FiTextItemMediaPanelItemBaseComponent,
        FiTextItemMediaPanelAlignmentComponent,
        FiTextItemMediaPanelSizeComponent,
        FiTextItemMediaPanelLinkComponent,
    ],
})
export class FiTextItemMediaPanelHandlerModule {}
